export enum Products {
  empower = 'Empower Platform',
  energyHq = 'EnergyHQ',
  intervals = 'Interval Data',
}
